import config from "../../config";

const mediaQueries = config.mediaQueries;

/**
 * returns current mediaQuery name. e.g. "MQ2"
 * @returns {mediaQuery} - mq name
 */
export const getCurrentMQ = (): string => {
  let mediaQuery = "";
  mediaQueries.forEach(mq => {
    if (!mediaQuery.length && window.matchMedia(mq.query).matches) {
      mediaQuery = mq.name;
    }
  });
  return mediaQuery;
};
